import { useRef, useState } from 'react'

import { isNullable } from '@app/utils'

import { initSize } from './utils'

import type { TableSize, UseTableSizeReturn } from './types'

export const useTableSize = (toggledSizes?: TableSize[]): UseTableSizeReturn => {
  const [size, setSize] = useState<TableSize>(initSize(toggledSizes))

  const sizeIndexRef = useRef(0)

  const handleSizeToggle = (): void => {
    if (isNullable(toggledSizes)) return

    sizeIndexRef.current++

    if (sizeIndexRef.current >= toggledSizes.length) {
      sizeIndexRef.current = 0
    }

    setSize(toggledSizes[sizeIndexRef.current])
  }

  return {
    size,
    onSizeChange: setSize,
    onSizeToggle: handleSizeToggle
  }
}
